import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';

export default server => {
    server.get('/v1/admin/rules', (schema, { queryParams: { business_profile_id: businessProfileId } }) => {
        const { models } = schema.rules.where(
            rule => parseInt(rule.business_profile_id) === parseInt(businessProfileId)
        );

        return models;
    });

    server.post('/v1/admin/rules', (schema, { requestBody }) => {
        const {
            business_profile_id,
            name,
            entities,
            query,
            exclude_query,
            rule_type,
            status_type,
            identities,
            label_ids
        } = JSON.parse(requestBody);

        const { attrs } = schema.rules.create({
            business_profile_id,
            name,
            entities,
            query,
            exclude_query,
            rule_type,
            status_type,
            identities,
            label_ids
        });

        return attrs;
    });

    server.patch('/v1/admin/rules/:id', (schema, { params: { id }, requestBody }) => {
        const rule = schema.rules.find(id);

        if (!rule) {
            return new Response(HTTP.NOT_FOUND);
        }

        const { name, entities, query, exclude_query, rule_type, status_type, identities, label_ids } = JSON.parse(
            requestBody
        );

        const { attrs } = rule.update({
            name,
            entities,
            query,
            exclude_query,
            rule_type,
            status_type,
            identities,
            label_ids
        });

        return attrs;
    });

    server.delete('/v1/admin/rules/:id', (schema, { params: { id } }) => {
        const rule = schema.rules.find(id);

        if (rule) {
            rule.destroy();
        }

        return new Response(HTTP.NO_CONTENT);
    });
};
